import { NgModule } from '@angular/core';
import { JsonFormsAngularService, JsonFormsModule } from '@jsonforms/angular';
import { JsonFormsAngularMaterialModule, angularMaterialRenderers } from '@jsonforms/angular-material';
import { JsonFormsCore, UISchemaElement, createAjv } from '@jsonforms/core';

const modules = [
  JsonFormsModule,
  JsonFormsAngularMaterialModule
];

@NgModule({
  declarations: [],
  imports: [
    modules
  ],
  exports: modules
})
export class ImportJsonformsModule {

  constructor(jsonformsService: JsonFormsAngularService) {
    const core = this.getCore();

    jsonformsService.init({
      core,
      renderers: [
        ...angularMaterialRenderers
      ],
    });
  }

  getCore(): JsonFormsCore {
    return {
      data: {},
      schema: {},
      uischema: {} as UISchemaElement,
      errors: [],
      ajv: this.getAvj()
    };
  }

  getAvj() {
    return createAjv({});
  }

}

